import PropTypes from 'prop-types';
import React from 'react';
import { CareTeamMember } from 'src/pages/facesheet/_id/Relationships/CareTeamMember/CareTeamMember';

export function CareTeamSection({
  className,
  contact,
  getClientRelationship,
  sectionTitle,
  visibilityConfig,
}) {
  if (!contact) {
    return null;
  }

  const relationshipVisibilityConfig = {
    overview: {
      showCareCoordinator: visibilityConfig?.overview?.showCareCoordinator ?? true,
      showCareTeam: visibilityConfig?.overview?.showCareTeam ?? true,
    },
  };

  return (
    <CareTeamMember
      className={className}
      person={contact}
      getClientRelationship={getClientRelationship}
      sectionTitle={sectionTitle}
      showHeader={false}
      visibilityConfig={relationshipVisibilityConfig}
    />
  );
}

CareTeamSection.propTypes = {
  className: PropTypes.string,
  contact: PropTypes.shape({
    id: PropTypes.string,
  }),
  getClientRelationship: PropTypes.func,
  sectionTitle: PropTypes.string,
  visibilityConfig: PropTypes.shape({
    overview: PropTypes.shape({
      showCareCoordinator: PropTypes.bool,
      showCareTeam: PropTypes.bool,
    }),
  }),
};

CareTeamSection.defaultProps = {
  className: '',
  contact: null,
  getClientRelationship: () => {},
  sectionTitle: '',
  visibilityConfig: {},
};

export default CareTeamSection;
